import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=047c3bdd&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047c3bdd')) {
      api.createRecord('047c3bdd', component.options)
    } else {
      api.reload('047c3bdd', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=047c3bdd&", function () {
      api.rerender('047c3bdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29Vr5jAPvAp2W/JS/ImageCarousel.vue"
export default component.exports